import {
  BAD_REQUEST_REASONS,
  type ServerMessage,
} from 'ts-components/PiChat/protocol';

type BadRequestReason = (typeof BAD_REQUEST_REASONS)[number];

const REFUSED_RESUME_CODES = new Set<string>([
  'not_found',
  'conversation_invalid',
]);
const REFUSED_RESUME_BAD_REQUESTS = new Set<BadRequestReason>([
  'invalid_conversation_id',
  'profile_mismatch',
  'binding_mismatch',
]);

export const isRefusedResume = (message: ServerMessage): boolean => {
  if (message.type !== 'error' || message.clientMessageId) return false;
  if (REFUSED_RESUME_CODES.has(message.code)) return true;
  return (
    message.code === 'bad_request' &&
    REFUSED_RESUME_BAD_REQUESTS.has(message.params.reason)
  );
};

export interface ResumeAttempt {
  sentConversationId: string | null;
  ready: boolean;
}

export const shouldStartFresh = (
  { sentConversationId, ready }: ResumeAttempt,
  message: ServerMessage
) => sentConversationId !== null && !ready && isRefusedResume(message);
